import { FC, ReactNode, useState } from 'react';
import Style                       from './CheckBox.style';

type TProps = {
  className?: string,
  checked: boolean,
  readonly?: boolean,
  disabled?: boolean,
  name?: string,
  label?: string,
  onChange?: (evt: any) => void,
  children?: ReactNode,
}

export const CheckBox: FC<TProps> = ({ label, children, checked, className, readonly, disabled, onChange }) => {

  const [ _checked, setChecked ] = useState(checked);

  const handleOnClick = () => {
    if (readonly || disabled) {
      return false;
    }
    setChecked(!_checked);
    onChange && onChange(!_checked);
  };

  let addClasses = '';

  if (_checked) {
    addClasses += ' checked';
  }
  if (!!readonly || !!disabled) {
    addClasses += ' readonly';
  }

  return (
    <Style className={className + addClasses + ' checkBox'} onClick={handleOnClick}>
      <span className="label">{label || children}</span>
    </Style>
  );
};
